import type { MessageFeedbackReaction } from 'tripPlanner/api/types'
import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

const REACTION_LABEL: Record<MessageFeedbackReaction, string> = {
  UP: 'positive',
  DOWN: 'negative',
}

// displayText stays purely referential -- no excerpt of the assistant message being reacted to.
// Echoing model output back into a customer-activity log the model itself reads is a real
// re-injection risk, and would force a truncation/sanitisation/classification design this avoids
// needing entirely. messageSeq (the BE-assigned conversation sequence number) reads better to the
// model than the raw message id and is exactly as stable for grouping purposes -- see
// recent-surface-activity-frontend-implementation-plan.md's §8. Sourced from the message's own
// server-assigned field rather than a locally-recomputed position, so it can't drift from
// whatever list-filtering the render layer applies (PR review finding on #37336).
export function buildMessageFeedbackActivityEntry(
  reaction: MessageFeedbackReaction,
  messageSeq: number,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'message_feedback_submitted',
    label: 'Gave message feedback',
    displayText: boundActivityDisplayText(
      `Gave ${REACTION_LABEL[reaction]} feedback on assistant message #${messageSeq}`,
    ),
    sourcePath: 'trip_planner.chat.message_feedback',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
